import { render, staticRenderFns } from "./panel_discount.vue?vue&type=template&id=a9c73d58&scoped=true&"
import script from "./panel_discount.vue?vue&type=script&lang=js&"
export * from "./panel_discount.vue?vue&type=script&lang=js&"
import style0 from "./panel_discount.vue?vue&type=style&index=0&id=a9c73d58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c73d58",
  null
  
)

export default component.exports